export default function style(theme) {
    return {
      root: {
        width: '98%',
        background:'transparent',
        boxShadow:'none',
        padding: '0rem',
        cursor: "none",
        [theme.breakpoints.down("sm")]: {
          width: '100%',
        },
      },
      heading: {
        fontSize: "1.12rem",
        fontWeight: 300,
        background:'transparent',
        padding: '0',
        cursor: "none",
      },
      description:{
        background: theme.palette.primary.main,
        cursor: "none",
        padding:'1rem',
        fontWeight: 400,
        borderRadius:'10px',
        width:'100%',
        margin:'0',
        border: '1px solid rgba(121, 131, 150, 0.15)',
        color: theme.palette.text.tertiary
      },
      icon: {
        color: theme.palette.text.highlight,
        cursor: "none",
      }
    };
  }